import "../css/dataschedule.css";
//import { selectedSlot, tmpSelectedSlot } from "..";
import { getJsonData } from "../getJsonData";
import { send } from "../send";
import { requiredFields, isValidEmail, isBlankString } from "./form";
import { articolazioneType } from "./form";

let selectedSlot = {
  day: false,
  time: false,
};

let tmpSelectedSlot = JSON.parse(JSON.stringify(selectedSlot));

window.selectedSlot = selectedSlot;
window.tmpSelectedSlot = tmpSelectedSlot;
const availability = 50;
const slotType = ["ITI", "Liceo"];

const getDateYYYYMMDD = (d) => {
  let date = new Date();
  if (d) date = new Date(d);
  return (
    date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate()
  );
};

const today = getDateYYYYMMDD();

export let timeoptions = {};

export const checkLastUpdate = async (time = false) => {
  tmpSelectedSlot = JSON.parse(JSON.stringify(selectedSlot));
  console.log(tmpSelectedSlot);
  console.log("checkLastUpdate");

  const timeoptiontime = !time ? timeoptions.time : time;
  const result = await getJsonData("?t=" + timeoptiontime);
  if (result.time !== false) {
    timeoptions = result;
    const d = document;
    const elSlots = d.getElementById("slots");
    elSlots.innerHTML = "";
    const elDays = d.getElementById("days");
    elDays.innerHTML = await printDates(result);

    selectDayEventListener();
    if (tmpSelectedSlot.day) {
      const lastSelectedDay = d.getElementById("day_" + tmpSelectedSlot.day);
      lastSelectedDay.click();
    }
  }
};

export const printDates = async (existingtimeoptions = false) => {
  let html = "";
  console.log("prima");
  if (!existingtimeoptions) timeoptions = await getJsonData();
  console.log("dopo");
  timeoptions.days.forEach((el, i) => {
    html += printDay(el, i);
  });
  console.log(html);
  return html;
};

const printDay = (d, index) => {
  const options = {
    //weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const data = new Date(d.day);
  return `<div id="day_${d.id}" class="select-day" data-day="${
    d.id
  }">${data.toLocaleString("it-IT", options)}</div>`;
};

export const selectDayEventListener = () => {
  const elements = document.getElementsByClassName("select-day");
  Array.from(elements).forEach(function (element) {
    element.addEventListener("click", selectDay);
  });
};

export const selectSlotEventListener = async () => {
  const elements = document.getElementsByClassName("select-slot");
  Array.from(elements).forEach(function (element) {
    element.addEventListener("click", selectSlot);
  });
};

const selectDay = (el) => {
  document.getElementById("submit").setAttribute("disabled", "disabled");

  if (document.querySelector(".select-day.selected"))
    document.querySelector(".select-day.selected").classList.remove("selected");
  const element = el.target;
  element.classList.add("selected");
  const selectedDay = el.target.dataset.day;
  console.log("selectedDay", selectedDay);
  const slots = timeoptions.days[selectedDay - 1].slots;
  console.log("slots", slots);
  selectedSlot.day = selectedDay;
  selectedSlot.time = false;
  printSlots(selectedDay, slots);
};

const selectSlot = (el) => {
  console.log("selected slot");

  let element = el.target;
  if (!element.dataset.free) {
    console.log("sono l'elemento interno");
    element = element.parentElement;
    console.log(element);
  }
  if (element.dataset.free > 0 || isForce()) {
    console.log(element.id);
    if (document.querySelector(".select-slot.selected"))
      document
        .querySelector(".select-slot.selected")
        .classList.remove("selected");
    selectedSlot.time = element.dataset.id;
    element.classList.add("selected");
    //submit
    document.getElementById("submit").removeAttribute("disabled");
  }
};

const printSlots = async (day, slots) => {
  let html = "";
  Array.from(slots).forEach((slot, index) => {
    slot.type = index % 2;
    if (articolazioneType == slot.type) {
      html += `<div id="slot_${day}_${slot.id}" class="select-slot d-flex flex-column`;
      if (slot.free <= 0) html += " not-available";
      html += `" data-day="${day}" data-id="${slot.id}" data-free="${
        slot.free
      }" data-type="${slot.type}">
    <span>${slotType[slot.type]}</span>
    <strong class="time-slot">${slot.time}</strong>
    <em>Posti disponibili: ${slot.free < 0 ? 0 : slot.free}</em>
    </div>`;
    }
  });
  document.getElementById("slots").innerHTML = html;
  console.log("await selectSlotEventListener(); prima");
  console.log(tmpSelectedSlot);
  await selectSlotEventListener();
  console.log("await selectSlotEventListener(); dopo");
  if (tmpSelectedSlot.day == selectedSlot.day) {
    if (tmpSelectedSlot.time) {
      console.log("tmpslected");
      console.log(tmpSelectedSlot);
      const d = document;
      const lastSelectedSlot = d.getElementById(
        "slot_" + tmpSelectedSlot.day + "_" + tmpSelectedSlot.time
      );
      lastSelectedSlot.click();
    }
  } else {
    tmpSelectedSlot.time = false;
  }
};

export const submitEventListener = () => {
  const submit = document.getElementById("submit");
  submit.addEventListener("click", submitForm);
};

const isForce = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const isForce = urlParams.get("force");
  return isForce == "true" ? true : false;
};

const submitForm = (e) => {
  e.preventDefault();
  let formElement = document.getElementById("prenotazione");
  let form = new FormData(formElement);
  form.append("day", selectedSlot.day);
  form.append("slot", selectedSlot.time);
  let formDataObj = {};
  let isValidForm = true;
  form.forEach((value, key) => (formDataObj[key] = value));
  formDataObj.articolazione = articolazioneType + "";
  console.log(formDataObj);
  console.log(requiredFields);
  setBtnSubmitStatus(false);

  if (isForce()) formDataObj["force"] = true;

  requiredFields.forEach((field) => {
    if (isBlankString(formDataObj[field]) || formDataObj[field] == undefined)
      isValidForm = false;
  });
  console.log("form in: " + isValidForm);
  if (!isValidForm) {
    alert("Controllare di aver compilato tutti i campi obbligatori");
    setBtnSubmitStatus(true);
    return;
  }

  if (!isValidEmail(formDataObj.parent_email)) {
    alert("Inserire un email valida");
    setBtnSubmitStatus(true);
    return;
  }
  send(formDataObj);
};

export const setBtnSubmitStatus = (status = true) => {
  if (status) {
    document.getElementById("submit").removeAttribute("disabled");
    document.getElementById("btnSpinner").classList.remove("active");
    return;
  }
  document.getElementById("submit").setAttribute("disabled", "disabled");
  document.getElementById("btnSpinner").classList.add("active");
};
